import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'formatEnum'
})
export class FormatEnum implements PipeTransform {

    transform(value: string): string {
        if (!value) return '';
        return value.replace(/_/g, ' ');
    }
}